import PropTypes from "prop-types";
import React from "react";

// We need to extend `Component` because `CompanyCard` extends `Card`
class Card extends React.Component {
  render() {
    const {
      content,
      children,
      hidden,
      calendar,
      plain,
      wizard,
      title,
      category,
      textCenter,
      ctAllIcons,
      ctFullWidth,
      ctTextCenter,
      tableFullWidth,
      stats,
      legend,
      ftTextCenter,
      className
    } = this.props;
    return (
      <div
        className={
          "card" +
          (className ? ` ${className}` : "") +
          (hidden ? " card-hidden" : "") +
          (calendar ? " card-calendar" : "") +
          (plain ? " card-plain" : "") +
          (wizard ? " card-wizard" : "")
        }>
        {title !== undefined || category !== undefined ? (
          <div className={"header" + (textCenter ? " text-center" : "")}>
            <h4 className="title">{title}</h4>
            <p className="category">{category}</p>
          </div>
        ) : (
          ""
        )}
        <div
          className={
            "content" +
            (ctAllIcons ? " all-icons" : "") +
            (ctFullWidth ? " content-full-width" : "") +
            (ctTextCenter ? " text-center" : "") +
            (tableFullWidth ? " table-full-width" : "")
          }>
          {children || content}
        </div>
        {stats !== undefined || legend !== undefined ? (
          <div className={"footer" + (ftTextCenter ? " text-center" : "")}>
            {legend !== undefined ? (
              <div className="legend">{legend}</div>
            ) : null}
            {stats !== undefined ? <hr /> : null}
            {stats !== undefined ? <div className="stats">{stats}</div> : null}
          </div>
        ) : null}
      </div>
    );
  }
}

Card.propTypes = {
  content: PropTypes.node,
  children: PropTypes.node,
  hidden: PropTypes.bool,
  calendar: PropTypes.bool,
  plain: PropTypes.bool,
  wizard: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  category: PropTypes.bool,
  textCenter: PropTypes.bool,
  ctAllIcons: PropTypes.bool,
  ctFullWidth: PropTypes.bool,
  ctTextCenter: PropTypes.bool,
  tableFullWidth: PropTypes.bool,
  stats: PropTypes.object,
  legend: PropTypes.object,
  ftTextCenter: PropTypes.bool
};

export default Card;
